<style scoped>
.border_right {
  border-right: 1px solid rgb(214, 214, 214);
  height: 35px;
  display: flex;
  align-items: center;
}
.div_right {
  height: 700px;
  width: 25%;
  overflow: auto;
  z-index: 0;
  position: relative;
}
.div_center {
  height: 700px;
  /* max-height: 700px; */
  width: 75%;
  border: 1px solid silver;
  border-top: none;
  overflow: auto;
  position: relative;
  margin-bottom: 20px;
}
.list-group-item {
  border: none;
  cursor: pointer;
}
.list-group-item:hover {
  background-color: whitesmoke;
}
.list-group .list-group-item span {
  background-color: #4467f24f;
  margin-right: 10px;
}
.list-group {
  border-bottom: 1px solid rgba(192, 192, 192, 0.555);
}
.page {
  height: 220px;
  width: 60%;
  border: 1px solid silver;
  margin-bottom: 25px;
}
.pied_page {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: rgba(216, 216, 216, 0.3);
}
.signature {
  border: 1px solid silver;
  z-index: 1;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: white;
  padding-bottom: 40px;
  box-shadow: 1px 2px 1px 2px rgba(0, 0, 0, 0.233);
}
.card-body .row .col-sm-3 label,
.card-body .row .col-sm-2 label {
  font-size: 12px;
}
</style>
<template>
  <div class="wrapper" style="overflow: auto">
    <div class="mt-2">
      <div
        class="d-flex justify-content-between align-items-center px-4 py-1"
        style=""
      >
        <div class="row">
          <span class="cursor-pointer p-1">
            <app-icon name="x" />
          </span>
          <div
            class="ml-3 pl-2 d-flex align-items-center"
            style="border-left: 1px solid black"
          >
            <span> Complétez avec DocumentSign :</span>
            <span class="ml-2">nom.pdf</span>
          </div>
        </div>
        <div class="row d-flex align-items-center px-4">
          <span class="mr-3 cursor-pointer">
            <app-icon name="help-circle" />
          </span>
          <div class="mr-3">
            <app-input
              type="select"
              :list="[{ id: 1, value: 'Action' }]"
              v-model="selectValue"
            />
          </div>
          <button class="btn btn-outline-dark mr-3">Apercu</button>
          <button href="" class="btn btn-primary rounded">
            Voir les forfaits
          </button>
        </div>
      </div>
      <div
        class="d-flex justify-content-between align-items-center mt-2 py-1"
        style="
          border-bottom: 1px solid rgb(214, 214, 214);
          background-color: #e9e9e9;
        "
      >
        <div class="mr-3">
          <app-input
            type="select"
            :list="[{ id: 1, value: 'Stephane Djamen' }]"
            v-model="selectValue"
          />
        </div>
        <div class="row d-flex align-items-center">
          <div class="border_right py-2 px-2">
            <span class="cursor-pointer">
              <i class="fa fa-reply text-secondary" aria-hidden="true"></i>
            </span>
            <span class="cursor-pointer ml-2">
              <i class="fa fa-share" aria-hidden="true"></i>
            </span>
          </div>
          <div class="border_right py-2 px-3">
            <span class="cursor-pointer">
              <i class="fa fa-clone" aria-hidden="true"></i>
            </span>
            <span class="cursor-pointer ml-3">
              <i class="fa fa-clipboard text-secondary" aria-hidden="true"></i>
            </span>
          </div>
          <div class="border_right py-2 px-2">
            <select class="cursor-pointer" style="background-color: inherit">
              <option>100%</option>
              <option>75%</option>
              <option>50%</option>
              <option>25%</option>
              <option>auto</option>
            </select>
          </div>
          <div class="border_right py-2 px-3">
            <span class="cursor-pointer">
              <i class="fa fa-comments" aria-hidden="true"></i>
            </span>
          </div>
          <div class="py-2 px-3">
            <a href="" class="text-secondary">
              <i class="fa fa-file" aria-hidden="true"></i>
            </a>
          </div>
        </div>
        <div>
          <button class="mr-2 text-lowercase shadow-none border">
            Raccourci
          </button>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-between"
      style="width: 100%; margin-top: 0px; position: relative; overflow: auto"
    >
      <div
        class="d-flex justify-content-end p-2"
        style="
          position: fixed;
          bottom: 0;
          width: 100%;
          border: 1px solid silver;
          z-index: 1;
          background-color: #d9d9d9;
          box-shadow: 1px 2px 1px 2px silver;
        "
      >
        <button class="btn btn-secondary mr-3">Retour</button>
        <button class="btn btn-success">Envoyer</button>
      </div>
      <div class="div_center pt-3 px-5 pb-4">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde, quod
          quos delectus, voluptatem eius eveniet sint, porro provident saepe et
          ut reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis? Lorem ipsum dolor
          sit amet consectetur adipisicing elit. Unde, quod quos delectus,
          voluptatem eius eveniet sint, porro provident saepe et ut
          reprehenderit quis maiores? Rem asperiores temporibus corrupti
          doloribus blanditiis? Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Unde, quod quos delectus, voluptatem eius eveniet
          sint, porro provident saepe et ut reprehenderit quis maiores? Rem
          asperiores temporibus corrupti doloribus blanditiis?
        </p>
      </div>
      <div class="div_right pt-2">
        <div class="signature">
          <div class="card-header">
            <h6><i class="fa fa-edit"></i> Signature</h6>
          </div>
          <div class="px-4">
            <div class="mt-2">
              <label
                data-toggle="collapse"
                data-target="#destinataire"
                aria-expanded="true"
                aria-controls="destinataire"
                class="font-weight-bold cursor-pointer"
                >Destinataire</label
              >
              <div class="collapse show" id="destinataire">
                <div class="">
                  <app-input
                    type="select"
                    :list="[
                      { id: 1, value: 'Stephane Djamen' },
                      { id: 2, value: 'Djamen' },
                      { id: 3, value: 'Stephane' },
                    ]"
                    v-model="selectValue"
                  />
                  <app-input
                    class="mt-2"
                    type="checkbox"
                    :list="[{ id: 1, value: 'Champ obligatoire' }]"
                    v-model="checkboxValue"
                  />
                  <!-- <app-input  type="text"/> -->
                </div>
              </div>
            </div>
            <div class="mt-2">
              <label
                data-toggle="collapse"
                data-target="#formatage"
                aria-expanded="false"
                aria-controls="formatage"
                class="font-weight-bold cursor-pointer"
                >Formatage</label
              >
              <div class="collapse" id="formatage">
                <div class="d-flex align-items-center">
                  <app-input type="number" />
                  <span class="text-secondary ml-2">Echelle en %</span>
                </div>
                <div class="d-flex">
                  <app-input
                    type="select"
                    :list="[
                      { id: 1, value: 'Lucida console' },
                      { id: 2, value: 'Georgia' },
                      { id: 3, value: 'Verdana' },
                    ]"
                    v-model="selectValue"
                  />
                  <app-input
                    class="ml-2"
                    type="select"
                    :list="[
                      { id: 1, value: '10' },
                      { id: 2, value: '12' },
                      { id: 3, value: '14' },
                    ]"
                    v-model="selectValue"
                  />
                  <app-input
                    class="ml-2"
                    type="select"
                    :list="[
                      { id: 1, value: 'Noir' },
                      { id: 2, value: 'Bleu' },
                      { id: 3, value: 'Violet' },
                    ]"
                    v-model="selectValue"
                  />
                </div>
              </div>
            </div>
            <div class="mt-2">
              <label
                data-toggle="collapse"
                data-target="#donnee"
                aria-expanded="false"
                aria-controls="donnee"
                class="font-weight-bold cursor-pointer"
                >Etiquette de données</label
              >
              <div class="collapse" id="donnee">
                <app-input type="text" />
              </div>
            </div>
            <div class="mt-2">
              <label
                data-toggle="collapse"
                data-target="#infobulle"
                aria-expanded="false"
                aria-controls="infobulle"
                class="font-weight-bold cursor-pointer"
                >Infobulle</label
              >
              <div class="collapse" id="infobulle">
                <app-input type="textarea" v-model="textarea" />
              </div>
            </div>
            <div class="mt-2">
              <label
                data-toggle="collapse"
                data-target="#emplcement"
                aria-expanded="false"
                aria-controls="emplcement"
                class="font-weight-bold cursor-pointer"
                >Emplacement</label
              >
              <div class="collapse" id="emplcement">
                <div class="d-flex align-items-center mb-2">
                  <app-input type="text" />
                  <span class="ml-2">pixel a partir de la gauche</span>
                </div>
                <div class="d-flex align-items-center">
                  <app-input type="text" />
                  <span class="ml-2">pixel a partir du haut</span>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn btn-outline-danger mr-3">Annuler</button>
              <button class="btn btn-primary">Enregistrer</button>
            </div>
          </div>
        </div>
        <div class="d-flex ml-1">
          <div class="mr-2">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <button
                class="nav-link active"
                id="v-pills-home-tab"
                data-toggle="pill"
                data-target="#v-pills-home"
                type="button"
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true"
                style="border: none"
                title="Champs standard"
              >
                <i class="fa fa-square"></i>
              </button>
              <button
                class="nav-link border-0"
                id="v-pills-profile-tab"
                data-toggle="pill"
                data-target="#v-pills-profile"
                type="button"
                role="tab"
                aria-controls="v-pills-profile"
                aria-selected="false"
                title="Custom value"
              >
                <i class="fa fa-tools"></i>
              </button>
              <button
                class="nav-link border-0"
                id="v-pills-messages-tab"
                data-toggle="pill"
                data-target="#v-pills-messages"
                type="button"
                role="tab"
                aria-controls="v-pills-messages"
                aria-selected="false"
                title="Custom field"
              >
                <i class="fa fa-edit"></i>
              </button>
            </div>
          </div>
          <div class="tab-content" id="v-pills-tabContent" style="width: 100%">
            <app-input
              type="advance-search-select"
              :loaded-per-time="5"
              v-model="advanceSearchSelectValue"
              fetch-url="test-search-select"
              placeholder="Search and select"
              list-value-field="name"
              :required="true"
            />
            <div
              class="tab-pane fade show active"
              id="v-pills-home"
              role="tabpanel"
              aria-labelledby="v-pills-home-tab"
              style="overflow: auto"
            >
              <div
                class=""
                style="
                  width: 100%;
                  border-left: 1px solid whitesmoke;
                  padding-bottom: 50px;
                "
              >
                <h6 class="font-weight-bold mt-2">Champs standards</h6>
                <ul class="list-group mb-3">
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-edit text-secondary"></i></span
                    >Signature
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-text-width text-secondary"></i
                    ></span>
                    Paraphe
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-calendar text-secondary"></i></span
                    >Date de signature
                  </li>
                </ul>
                <ul class="list-group mb-3">
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-user text-secondary"></i></span
                    >Nom
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-envelope text-secondary"></i></span
                    >Email
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-briefcase text-secondary"></i></span
                    >Fonction
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-university text-secondary"></i></span
                    >Société
                  </li>
                </ul>
                <ul class="list-group mb-3">
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-text-height text-secondary"></i></span
                    >Texte
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-check-square text-secondary"></i></span
                    >Case a cocher
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i
                        class="fa fa-chevron-circle-down text-secondary"
                      ></i></span
                    >Liste deroulante
                  </li>
                  <li class="list-group-item">
                    <span class="p-1"
                      ><i class="fa fa-circle text-secondary"></i></span
                    >Bouttons radio
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="v-pills-profile"
              role="tabpanel"
              aria-labelledby="v-pills-profile-tab"
            >
              <h6 class="font-weight-bold mt-2">Customs values</h6>
              <ul class="list-group mb-3">
                <li class="list-group-item">
                  <span class="p-1"
                    ><i class="fa fa-text-height text-secondary"></i></span
                  >Texte
                </li>
                <li class="list-group-item">
                  <span class="p-1"
                    ><i class="fa fa-check-square text-secondary"></i></span
                  >Case a cocher
                </li>
                <li class="list-group-item">
                  <span class="p-1"
                    ><i
                      class="fa fa-chevron-circle-down text-secondary"
                    ></i></span
                  >Liste deroulante
                </li>
                <li class="list-group-item">
                  <span class="p-1"
                    ><i class="fa fa-circle text-secondary"></i></span
                  >Bouttons radio
                </li>
              </ul>
            </div>
            <div
              class="tab-pane fade"
              id="v-pills-messages"
              role="tabpanel"
              aria-labelledby="v-pills-messages-tab"
            >
              <h6 class="font-weight-bold mt-2">Customs fields</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

export default {
  name: "TestValidation",
  mixins: [FormMixin],
  data() {
    return {
      test: "",
    };
  },
  methods: {},
};
</script>
